<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Blacklisted Applicant List">
      <template slot="actions">
        <vx-input-group class="mb-base">
          <vs-input class="w-full" placeholder="Enter Nid No" @keypress="onlyNumber"
                    v-model="searchParam"/>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="primary" icon-pack="feather" icon="icon-search"
                         @click="serachInActiveApplicant(searchParam)">
              </vs-button>
            </div>
          </template>
        </vx-input-group>

      </template>
      <vs-table stripe
                :sst="true"
                @change-page="handleChangePage"
                v-model="selected"
                :total="blockedApplByValidateStatus.total"
                pagination
                :max-items=15
                :data="blockedApplByValidateStatus.data">
        <!--<template slot="header">
          <h3>
            All Applicant
          </h3>
        </template>-->
        <template slot="thead">
          <vs-th sort-key="name">
            Name
          </vs-th>
          <vs-th sort-key="phone">
            Mobile
          </vs-th>
          <vs-th sort-key="nid">
            Nid no
          </vs-th>
          <vs-th sort-key="status">
            Nid Validation Status
          </vs-th>
          <vs-th sort-key="id">
            Action
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr]">
              {{data[indextr].parsonal.name}} {{data[indextr].parsonal.last_name}}
            </vs-td>

            <vs-td :data="data[indextr].phone">
              {{data[indextr].phone}}
            </vs-td>

            <vs-td :data="data[indextr].nid">
              {{data[indextr].nid}}
              <vs-button color="primary" size="small" @click="showNidChangePopup(data[indextr].id, data[indextr].nid)">
                Change Nid
              </vs-button>
            </vs-td>

            <vs-td :data="data[indextr].validate_by_nid">
              {{data[indextr].validate_by_nid==3?"Blocked":"Blacklisted"}}
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <vs-button color="primary" size="small" @click="unblockClient(data[indextr].nid)">
                Unblock
              </vs-button>
<!--              <div class="demo-alignment">
&lt;!&ndash;                <feather-icon icon="EyeIcon" @click="applicantDetal(data[indextr].user_id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
                <feather-icon color="danger" icon="UserPlusIcon" @click="unBlock(data[indextr].id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>&ndash;&gt;

              </div>-->
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <template lang="html">
      <div class="centerx">
        <vs-popup class="holamundo" title="Change Nid Number" :active.sync="popupActivo">
          <vx-card>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/1 w-full mt-4">
                  <span>New Nid No</span>
                </div>
                <div class="vx-col sm:w-1/1 w-full">
                  <vx-input-group class="mb-base">
                    <vs-input class="w-full"  data-vv-as="Mobile No"
                              @keypress="onlyNumber" v-model="newNidNo" name="Nid"/>
                    <span class="text-danger text-sm" v-show="errors.has('Nid')">{{ errors.first('Nid') }}</span>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="primary" @click="changeNid(selectedId, newNidNo)">Change</vs-button>
                      </div>
                    </template>
                  </vx-input-group>
                  <!--                    <vs-input class="w-full" v-validate="'required|min:11|max:11'" data-vv-as="Mobile No" @keypress="onlyNumber"  v-model="mobile" name="mobile"/>-->
                  <!--                    <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>-->
                </div>
              </div>
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </template>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from "../../axios";

export default {
  data() {
    return {
      selectedPgae: 1,
      searchParam: '',
      selected: [],
      popupActivo: false,
      selectedId: '',
      newNidNo:''
    }
  },
  computed: {
    ...mapGetters(['meta', 'blockedApplByValidateStatus'])
  },
  mounted() {
     this.$store.dispatch('getBlockedApplByValidateStatus', '3?page=' + this.selectedPgae);

  },
  watch: {
    searchParam(value){
      if(value.length < 1){
        this.$store.dispatch('getBlockedApplByValidateStatus', '3?page=' + this.selectedPgae);
      }
    }
  },
  methods: {
    handleChangePage(page) {
      this.selectedPgae = page;
      this.$store.dispatch('getBlockedApplByValidateStatus', '3?page=' + this.selectedPgae);
    },
    applicantDetal(id) {
      this.$router.push('/applicant-details/' + id).catch(() => {
      })
    },
    unblockClient(nid){
      axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/nidVerifiedByUpdateStatus/${nid}/0`).then(res => {
        console.log("====>>",res)
        if(res.data === "validate"){
          this.$store.dispatch('getBlockedApplByValidateStatus', '3?page=' + this.selectedPgae);
          this.$vs.notify({
            title: 'Unblocked',
            text: 'Successfully Unblocked.',
            color: "success",
            position: 'top-right'
          })
        }
      })
    },
    changeNid(ekyc_id, nidNo){
      axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/updateApplicantNidNo/${ekyc_id}/${nidNo}`).then(res => {
        console.log("==", res)
        if(res.status === 200){
          this.popupActivo = false;
           this.$vs.notify({
            title: 'Success',
            text: 'Nid Change Successfully.',
            color: "success",
            position: 'top-right'
          })
          this.$store.dispatch('getBlockedApplByValidateStatus', '3?page=' + this.selectedPgae);
        }else {
          this.$vs.notify({
            title: 'Error!',
            text: 'Failed to change nid.',
            color: "danger",
            position: 'top-right'
          })
        }
      })
      console.log(ekyc_id);
      console.log(nidNo);
    },
    showNidChangePopup(ekyc_id, nid) {
      this.popupActivo = true;
      this.newNidNo = nid;
      this.selectedId = ekyc_id;
      console.log(ekyc_id);
      console.log(nid);
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault()
      }
    },
    async unBlock(id) {
      const unBlockUser = {
        id: id,
        data: {
          status: 1
        }
      };
      console.log("ID", id);
      await this.$store.dispatch('updateApplicant', unBlockUser);
      await this.$store.dispatch('getApplicantList', 'applicants?status=false&page=' + this.selectedPgae);
    },
    serachInActiveApplicant(searchParam){
      this.$store.dispatch('searchBlockedApplListByValidateStatus', searchParam);
    }
  }
}
</script>
